import { findPartner } from "@/utils/constants/findPartner";
import {
  PersonIcon,
  HamburgerMenuIcon,
  DashboardIcon,
} from "@radix-ui/react-icons";
import { Container, Flex, Box, Button, Grid, Avatar } from "@radix-ui/themes";
import { SideMenuMobileUi } from "branchAndBrandSpecific/layout/sideNavigation/components/SideMenu.mobile.ui";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import React, { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavigationBarAvatar from "./NavigationBarAvatar";
import NotificationRender from "./NotificationRender";
import PartnerLogo from "./PartnerLogo";

interface LayoutProps {
  show: boolean;
  closeWindow?: (value: boolean) => void;
  isAuth: boolean;
  profile: any;
  currentClient: string;
  currentUser: any;
}

const NavigationBarLayoutSmall: FC<LayoutProps> = ({
  show,
  closeWindow,
  isAuth,
  profile,
  currentUser,
  currentClient,
}): JSX.Element => {
  const navigate = useNavigate();

  const isBestGamer = brand.brandValue === "BG";
  const isElgiganten = brand.brandValue === "ELGIGANTEN";

  return (
    <>
      <SideMenuMobileUi
        show={show}
        closeWindow={closeWindow}
        isAuth={!!isAuth}
        profile={profile}
      />

      <header className="header">
        <Container
          className="header__container container"
          size="4"
          py="4"
          px="4"
        >
          <Grid gap="3" columns="6" align="center">
            <Box gridColumnStart="1" gridColumnEnd="2">
              <Box>
                {isElgiganten || isBestGamer ? (
                  findPartner(currentClient) ? (
                    <Button variant="ghost" onClick={() => navigate("/home")}>
                      <img src={brand.logos.white} height={40} width={40} />
                    </Button>
                  ) : (
                    <Button
                      variant="ghost"
                      onClick={() => navigate("/profile")}
                    >
                      <Avatar
                        variant="solid"
                        radius="full"
                        size="3"
                        src={profile.profileLogoUrl}
                        fallback={profile.userName.slice(0, 1)}
                      />
                    </Button>
                  )
                ) : (
                  <Button variant="ghost" onClick={() => navigate("/profile")}>
                    <Avatar
                      variant="solid"
                      radius="full"
                      size="3"
                      src={profile.profileLogoUrl}
                      fallback={profile.userName.slice(0, 1)}
                    />
                  </Button>
                )}
              </Box>
            </Box>

            <Flex
              gridColumnStart="2"
              gridColumnEnd="6"
              justify="center"
              align="center"
            >
              <PartnerLogo isMobile={true} currentClient={currentClient} />
            </Flex>

            <Flex
              gap="2"
              align="center"
              justify="end"
              gridColumnStart="6"
              gridColumnEnd="7"
            >
              {brand.hasFeature.notifications && (
                <NotificationRender
                  profile={profile}
                  currentUser={currentUser}
                />
              )}
              <Button
                variant="ghost"
                size="3"
                onClick={() => closeWindow(true)}
              >
                <HamburgerMenuIcon width={32} height={32} />
              </Button>
            </Flex>
          </Grid>
        </Container>
      </header>
    </>
  );
};

export default NavigationBarLayoutSmall;
